import List from './list.vue';
import Edit from './edit.vue';
import Games from './games/';

export default {
  List,
  Edit,
  Games,
};
